import { inject, Injectable } from '@angular/core';

import { Observable, switchMap } from 'rxjs';

import { TellentSocketService } from '@core/tellent-data';

export enum SkillsImportEvent {
  Processing = 'processing',
  Done = 'done',
  Failed = 'failed',
}

export type SkillsImportProgressMessage =
  | { event: SkillsImportEvent.Processing }
  | { event: SkillsImportEvent.Done };

export type SkillsImportErrorMessage = { event: SkillsImportEvent.Failed; reason: string };

@Injectable({ providedIn: 'root' })
export class SkillsImportProgressTrackService {
  private readonly socket = inject(TellentSocketService);

  public track(importId: number): Observable<SkillsImportProgressMessage> {
    return this.socket.ready$.pipe(
      switchMap(
        () =>
          new Observable<SkillsImportProgressMessage>(observer => {
            const channel = this.socket.socket.channel(`skills_import:${importId}`);

            channel.on(SkillsImportEvent.Processing, payload => {
              observer.next({ event: SkillsImportEvent.Processing });
            });
            channel.on(SkillsImportEvent.Done, payload => {
              observer.next({ event: SkillsImportEvent.Done });
              observer.complete();
            });
            channel.on(SkillsImportEvent.Failed, (payload: { reason: string }) => {
              observer.error({ event: SkillsImportEvent.Failed, reason: payload.reason });
            });

            channel.join();
            return () => channel.leave();
          }),
      ),
    );
  }
}
